import { Injectable, inject } from '@angular/core';

import type { TrailerSensorData } from '@asset-solutions/customer-portal/orders/models';
import type { Tractor } from '@asset-solutions/customer-portal/tractors/models';
import { HttpService } from '@asset-solutions/shared/http';
import { toLocalISOString } from '@asset-solutions/shared/utilities';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EquipmentService {
  private apiPath = '/equipment';
  private httpService = inject(HttpService);

  public getCustomerTractors(): Observable<Tractor[]> {
    return this.httpService.get({ api: `${this.apiPath}/tractors` });
  }

  public getSensorData(trailerId: string, startDate: Date, endDate?: Date): Observable<TrailerSensorData[]> {
    return this.httpService.get({
      api: `${this.apiPath}/${trailerId}/temp-sensor-data`,
      searchParameters: {
        startDate: toLocalISOString(startDate),
        endDate: endDate ? toLocalISOString(endDate) : undefined
      }
    });
  }
}
